import Spinner from 'shared/timber/deprecated/spinner'
import DOMPurify from 'dompurify'

import styles from './HydratedDescription.module.scss'

type DescriptionProps = {
  isLoading: boolean
  dataTestId?: string
  description?: string | null
}

export default function HydratedDescription({
  isLoading = false,
  dataTestId,
  description,
}: DescriptionProps) {
  if (isLoading) return <Spinner />
  if (!description) return null

  // Replace <p></p> with <br /> to preserve line breaks. And replace \n\n with <br /><br /> as well
  const htmlWithBreaks =
    description
      ?.replace(/<p><\/p>/g, '<br />')
      ?.replace(/\n\n/g, '<br /><br />') ?? ''

  // Gotta prevent XSS attacks
  const cleanHtml = DOMPurify.sanitize(htmlWithBreaks)

  // Add _blank to all links. We do this here because DOMPurify doesn't allow us to do it
  const updatedHtml = cleanHtml?.replace(/<a/g, '<a target="_blank"')

  return (
    <div
      data-testid={dataTestId}
      className={styles.HydratedDescription}
      dangerouslySetInnerHTML={{ __html: updatedHtml }}
    />
  )
}
